import { Button } from '#base/js/common/components/button'
import { useState } from 'react'
import { useStyles } from './cookie-banner.style'

const DISMISSED = 'dismissed'

export function CookieBanner () {
  const classes = useStyles()
  const [showBanner, setShowBanner] = useState(localStorage.getItem('cookie-banner') !== DISMISSED)

  function getTrackerConfig () {
    return window._paq ?? []
  }

  function agree () {
    const trackerConfig = getTrackerConfig()
    trackerConfig.push(['rememberCookieConsentGiven'])
    dismiss()
  }

  function decline () {
    const trackerConfig = getTrackerConfig()
    trackerConfig.push(['forgetCookieConsentGiven'])
    dismiss()
  }

  function dismiss () {
    localStorage.setItem('cookie-banner', DISMISSED)
    setShowBanner(false)
  }

  if (!showBanner) {
    return null
  }

  return (
    <div className={classes.cookieBanner}>
      <div className={classes.cookieMessage}>
      We use cookies to analyse our traffic and usage of this site. This allows us to learn from your actions and
      create a better experience for you and other users. Clicking &quot;Decline&quot; will prevent this website from aggregating
      and analyzing the actions you take here. Clicking &quot;Accept&quot; will give us the permission to collect Strictly
      Necessary, Functional, and Performance Cookies, details of which are outlined in the following link: <a
      href="https://www.amgen.eu/cookie-information-for-users" target="_blank">Cookie Information</a>
      </div>
      <div className={classes.cookieButtons}>
        <Button onClick={decline} variant="link">Decline</Button>
        <Button onClick={agree}>Accept</Button>
      </div>
    </div>
  )
}
